export type RouterNavigateCallback = (location: Location, event: Event | null) => void

export function router (navigateCallback: RouterNavigateCallback) {
  document.body.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey)
      return;

    const anchor = event.composedPath().find((el) => (el as Element).tagName === 'A') as HTMLAnchorElement;

    if (!anchor || anchor.target || anchor.hasAttribute('download') || anchor.getAttribute('rel') === 'external')
      return;

    if (!anchor.href || anchor.href.indexOf('mailto:') !== -1 || anchor.href.indexOf(location.origin) !== 0)
      return;

    event.preventDefault();

    if (anchor.href === location.href)
      return;

    window.history.pushState({}, '', anchor.href);
    navigateCallback(location, event)
  });

  window.addEventListener('popstate', event => navigateCallback(location, event));
  navigateCallback(location, null)
}
